import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API, { getAuthConfig } from "../services/api";

function AddVisitor(){
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [purpose, setPurpose] = useState("");
  const [photo, setPhoto] = useState(null);

  const handleSubmit = async () =>{
    if(!name || !email || !phone){
      alert("Please fill all required fields");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("purpose", purpose);

    if(photo){
      formData.append("photo", photo);
    }

    try{
      const config = getAuthConfig();
      await API.post("/visitors", formData, config);
      alert("Visitor added successfully. It is pending approval.");
      navigate("/dashboard");
    } 
    catch(err){
      alert(err.response?.data?.message || "Failed to add visitor");
    }
  };

  return(
    <div className="p-8 max-w-lg mx-auto bg-white shadow-lg rounded-xl mt-10">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">Register New Visitor</h2>
      <div className="space-y-4">
        <input className="w-full border p-3 rounded-lg" placeholder="Name" onChange={e => setName(e.target.value)} />
        <input className="w-full border p-3 rounded-lg" placeholder="Email" onChange={e => setEmail(e.target.value)} />
        <input className="w-full border p-3 rounded-lg" placeholder="Phone" onChange={e => setPhone(e.target.value)} />
        <input className="w-full border p-3 rounded-lg" placeholder="Purpose" onChange={e => setPurpose(e.target.value)} />
        <div className="bg-gray-50 p-3 rounded-lg border border-dashed border-gray-300">
          <p className="text-xs text-gray-500 mb-2">Upload Photo (Optional)</p>
          <input type="file" accept="image/*" onChange={e => setPhoto(e.target.files[0])} />
        </div>
        <button onClick={handleSubmit} className="w-full bg-blue-600 text-white p-4 rounded-lg font-bold hover:bg-blue-700 transition">
          Submit Visitor
        </button>
        <button onClick={() => navigate("/dashboard")} className="w-full text-gray-500 text-sm py-2">Cancel</button>
      </div>
    </div>
  );
}

export default AddVisitor;
